{
  "title": "Aeronaves en tránsito y residentes – {{fboName}}",
  "search": {
    "placeholder": "Buscar por matrícula, propietario o modelo"
  },
  "filters": {
    "showTenants": {
      "label": "Mostrar inquilinos",
      "all": "Mostrar arrendatarios",
      "unassigned": "Mostrar sin asignar",
      "assignedTo": "Asignado a {{locationName}}"
    },
    "currentLocation": {
      "label": "Mostrar por ubicación actual"
    }
  },
  "columns": {
    "tailNumber": "Matrícula",
    "ownerManager": "Propietario/Gerente",
    "model": "Modelo",
    "currentLocation": "Ubicación actual",
    "assignedLocation": "Ubicación asignada",
    "type": "Tipo",
    "lastHangared": "Último hangaraje",
    "note": "Nota"
  },
  "actions": {
    "edit": "Editar"
  },
  "deleteConfirmation": {
    "title": "¿Seguro que desea eliminar {{identifier}}?",
    "message": "Esta aeronave se eliminará permanentemente.",
    "confirm": "Sí"
  },
  "locationText": {
    "notHangared": "No en hangar"
  }
}
